import { Flex, Text } from '@chakra-ui/react'

import { CopyItem } from 'components/icons'
import toast from 'utils/toast'
import { MessageCenterMessageCardActionsProps } from '../..'

export default function MessageCenterCopyMessage({ message, setMenuPosition }: MessageCenterMessageCardActionsProps) {
  async function handleCopyText() {
    try {
      await navigator.clipboard.writeText(message.message || '')
      toast.success('Text copiadom com sucesso!')
      setMenuPosition(null)
    } catch (err) {
      toast.error('Erro ao copiar texto')
    }
  }

  return (
    <Flex
      align="center"
      p={2}
      gap={2}
      className="accessible"
      _hover={{ bg: 'primary', color: 'light' }}
      onClick={handleCopyText}
    >
      <CopyItem />
      <Text>Copiar</Text>
    </Flex>
  )
}
